import { Injectable } from '@angular/core';
import {Product} from "../model/Product";
import {Type} from "../model/Type";
import {Photo} from "../model/Photo";
import {Http, Response} from "@angular/http";
import { Headers, RequestOptions } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import {AuthenticationService} from "./authentication.service";
import {environment} from "../../environments/environment";

@Injectable()
export class ProductService {

    productUrl = environment.instantPaiementApi + "products";

    constructor(private http: Http,
                private authenticationService: AuthenticationService) {}


    getProduct(id: number): Promise<Product> {
        return this.http.get(this.productUrl + "/" + id)
            .toPromise()
            .then(response => response.json() as Product)
            .then(undefined, (error) => { console.error(error); })
            .catch(this.handleError);
        //return Promise.resolve(this.product);
    }

    getListProducts(displayActives: boolean): Promise<Product[]> {
        //If displayActives = false, we want to display all actives and inactives
        return this.http.get(this.productUrl + (displayActives?"?state=1":""))
            .toPromise()
            .then(response => response.json() as Product[])
            .then(undefined, (error) => { console.error(error); })
            .catch(this.handleError);
    }

    addProduct(product:Product): Promise<Product> {
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.authenticationService.getToken() });
        let options = new RequestOptions({ headers: headers });
        return this.http.post(this.productUrl, product, options).toPromise()
            .then(this.extractData)
            .then(undefined, (error) => {
                if(error.json().error.code == 401) this.authenticationService.logout();
                console.log("code erreur ==> " + error.json().error.code);
                return error;
            })
            .catch(this.handleError);
    }

    modifyProduct(product:Product): Promise<Product> {
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.authenticationService.getToken() });
        let options = new RequestOptions({ headers: headers });
        return this.http.put(this.productUrl + "/" + product.id, product, options).toPromise()
            .then(this.extractData)
            .then(undefined, (error) => {
                if(error.json().error.code == 401) this.authenticationService.logout();
                return error;
            })
            .catch(this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        return body.data || { };
    }

    handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }

}


// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/services/product.service.ts